import { jsx, jsxs, Fragment } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { forwardRef } from "react";
import { SearchCardContainer } from "./components/SearchCardContainer.es.js";
import { Typography } from "../typography/typography.es.js";
import { Alignment } from "../../foundations/alignment.es.js";
import { getMainColor } from "./utils/getMainColor.es.js";
import { CustomIconCard } from "./components/CustomIconCard.es.js";
import { SearchCardContent } from "./components/SearchCardContent.es.js";
import { IconButton } from "../icon-button/icon-button.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { AngleRightSmallOutlined as C } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/angle-right-small-outlined.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { ProductCardContent } from "../product-card/components/product-card-content.es.js";
import Grid from "../../../node_modules/@mui/material/Grid/Grid.es.js";
const SearchCard = forwardRef(function Card({
  type,
  isSmall = false,
  isMobile = false,
  value,
  ...rest
}, ref) {
  const selectedColor = getMainColor(type);
  const isSmallBasedOnMobile = isMobile || isSmall;
  const typographyVariant = isSmallBasedOnMobile ? "body2" : "body1";
  return /* @__PURE__ */ jsx(SearchCardContainer, { elevation: 0, accentColor: selectedColor, ref, ...rest, children: /* @__PURE__ */ jsxs(ProductCardContent, { isMobile, "data-testid": "search-card-container-content-flexed", children: [
    /* @__PURE__ */ jsx(Grid, { container: true, justifyContent: Alignment.spaceBetween, wrap: "nowrap", children: /* @__PURE__ */ jsxs(SearchCardContent, { "data-testid": "search-card-content", children: [
      /* @__PURE__ */ jsx(CustomIconCard, { type, color: selectedColor }),
      /* @__PURE__ */ jsx(Typography, { variant: typographyVariant, children: value })
    ] }) }),
    isSmallBasedOnMobile ? /* @__PURE__ */ jsx(Fragment, {}) : /* @__PURE__ */ jsx(IconButton, { children: /* @__PURE__ */ jsx(C, { "data-testid": "search-card-angle-right-icon" }) })
  ] }) });
});
export {
  SearchCard
};
//# sourceMappingURL=search-card.es.js.map
